import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IB2BService, IB2BServiceState } from "./b2bserviceModel";
import {
  b2bServiceActiveInactive,
  createB2BService,
  deleteB2BService,
  getAllActiveB2BServices,
  getAllB2BServices,
  getB2BServiceByID,
  updateB2BService,
} from "./service/b2bservice.services";

const initialState: IB2BServiceState = {
  loading: false,
  formLoading: false,
  error: "",
  B2BServiceList: [],
  B2BServiceID: null,
  B2BServiceDetail: {
    ServiceName: "",
    IsActive: 1,
  },
};

const b2bServiceSlice = createSlice({
  name: "b2bservice",
  initialState,
  reducers: {
    clearB2BServiceDetails: (state) => {
      state.B2BServiceDetail = initialState.B2BServiceDetail;
    },
    setB2BServiceID: (state, action) => {
      state.B2BServiceID = action.payload;
    },
    clearB2BServiceID: (state) => {
      state.B2BServiceID = initialState.B2BServiceID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllB2BServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllB2BServices.fulfilled,
      (state, action: PayloadAction<IB2BService[]>) => {
        state.loading = false;
        state.B2BServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllB2BServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.B2BServiceList = [];
    });
    builder.addCase(getAllActiveB2BServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveB2BServices.fulfilled,
      (state, action: PayloadAction<IB2BService[]>) => {
        state.loading = false;
        state.B2BServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveB2BServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.B2BServiceList = [];
    });
    builder.addCase(createB2BService.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createB2BService.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createB2BService.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateB2BService.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateB2BService.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateB2BService.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteB2BService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteB2BService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteB2BService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(b2bServiceActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(b2bServiceActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(b2bServiceActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getB2BServiceByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getB2BServiceByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.B2BServiceDetail = action.payload;
    });
    builder.addCase(getB2BServiceByID.rejected, (state, action) => {
      state.formLoading = false;
      state.B2BServiceDetail = initialState.B2BServiceDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearB2BServiceDetails, setB2BServiceID, clearB2BServiceID } =
  b2bServiceSlice.actions;
export default b2bServiceSlice.reducer;
